import { Controller } from "@hotwired/stimulus";
import { clearFieldErrors } from "../lib/clear_field_errors";

export default class extends Controller {
  static targets = ["answer", "status", "statusLabel", "error"];

  connect() {
    this.updateStatus();
  }

  changed() {
    this.updateStatus();
    clearFieldErrors(this.element);
  }

  updateStatus() {
    const option = this.answerTarget.selectedOptions[0];
    this.statusLabelTarget.textContent = option.dataset.status;
    this.statusTarget.dataset.quality = option.dataset.quality;
  }
}
